import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, GuardsCheckEnd, ParamMap, Params, Router } from '@angular/router';
import { AppSettingsUrl } from './appSettings.prod';
import { LocalStorageService, PushService, TranslationService } from './services';
import { LanguageType } from './services/external/config/misc';

//Firebase
import { FirebaseApp } from '@angular/fire/app';
import { getMessaging, getToken, Messaging } from '@angular/fire/messaging';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.less']
})
export class AppComponent implements OnDestroy, OnInit {
	title = 'Mark Tools UI';
	//refid: string;
	lang: string;
	langs: any = LanguageType; 

	private pushToken:string;

	constructor(private activatedRoute: ActivatedRoute,
		private storage: LocalStorageService,
		private router: Router,
		private translate: TranslationService,
		private pushSrv: PushService
		) {
			
		
	}
	ngOnInit(): void {
		this.pushSrv.requestPermission().subscribe(s=>{
			this.pushToken =s;
			console.log(`Push token: ${this.pushToken}` );
		});
	}
	async ngOnDestroy(): Promise<void> {
		await this.pushSrv.deleteToken(this.pushToken);
	}
 
}
